import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase, AngularFireObject  } from 'angularfire2/database';
import { AuthService } from '../../auth/auth-service';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Task } from '../../models/task';
import { MatDialog } from '@angular/material';
import { UpdateTaskModalComponent } from '../update-task-modal/update-task-modal.component';
import { TasksServices } from '../tasks-services';

@Component({
  selector: 'app-list-tasks',
  templateUrl: './list-tasks.component.html',
  styleUrls: ['./list-tasks.component.css']
})
export class ListTasksComponent implements OnInit {
  tasksList: Task[] = [];

  constructor(public dialog: MatDialog
    , private taskService: TasksServices) {
      this.tasksList =  taskService.getTasks();
  }

  ngOnInit() {
  }


  onEditTaskModal(task: Task): void {
    // tslint:disable-next-line:prefer-const
    let dialogRef = this.dialog.open(UpdateTaskModalComponent, {
      width: '500px',
      data: {task}
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result === 'cancel') {
        return;
      }

      this.taskService.Update(result.task as Task);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/tasks/list-tasks/list-tasks.component.ts